import styles from "./WhiteLabelGuard.module.scss";
import { getWhiteLabelConfig } from "./getWhiteLabelConfig";

export const WhiteLabelGuard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const config = getWhiteLabelConfig();

  if (config.host === window.location.host) {
    return children;
  }

  return (
    <div className={styles.container}>
      Your SEO dashboard is located at{" "}
      <a href={config.host} rel="noopener noreferrer">
        {config.host}
      </a>
    </div>
  );
};
